module.exports = __webpack_public_path__ + "img/bronze.652265eb.jpg";